export const getAllCrewEmployeeSuccess = "GET_ALL_CREW_EMPLPOYEE_SUCCESS";
export const getAllCrewEmployeeFail = "GET_ALL_CREW_EMPLPOYEE_FAIL";
export const addNewCrewEmployeeSuccess = "ADD_NEW_CREW_EMPLOYEE_SUCCESS";
export const addNewCrewEmployeeFail = "ADD_NEW_CREW_EMPLOYEE_FAIL";
export const editExistingCrewEmployeeSuccess = "EDIT_EXISTING_CREW_EMPLOYEE_SUCCESS";
export const editExistingCrewEmployeeFail = "EDIT_EXISTING_CREW_EMPLOYEE_FAIL";
export const deleteExistingCrewEmployeeSuccess = "DELETE_EXISTING_CREW_EMPLOYEE_SUCCESS";
export const deleteExistingCrewEmployeeFail = "DELETE_EXISTING_CREW_EMPLOYEE_FAIL";